import { ApplicationRef, ChangeDetectorRef, Injectable, NgZone } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, UntypedFormGroup } from '@angular/forms';
import { IdmUtilities } from '@platform-idm/sdk-javascript';
import Keyboard from 'simple-keyboard';



export class VirtualKeyboardServiceMap {
  id: string;
  control: AbstractControl
}
@Injectable({providedIn:'root'})
export class VirtualKeyboardService {

  private enableKey = "mx1.onScreenKeyboardEnabled";
  private showKey = "mx1.showOnScreenKeyboard";

  getShowOnscreenKeyboard() {
    return this.utility.readCookie(this.showKey) == "true";
  }
  getOnscreenKeyboardEnabled() {
    return this.utility.readCookie(this.enableKey) == "true";
  }
  utility = new IdmUtilities();


  //we save the values for this number of minutes, in case there is no a proper logout. 5min to going from shared login or sec questions to the app
  readonly cookieTimeoutMinutes = 5;

  saveShowOnscreenKeyboard(showOnscreenKeyboard: boolean, onscreenKeyboardEnabled:boolean) {
    this.utility.writeCookie(this.showKey, showOnscreenKeyboard?.toString(), 60 * this.cookieTimeoutMinutes, false);
    this.utility.writeCookie(this.enableKey, onscreenKeyboardEnabled?.toString(), 60 * this.cookieTimeoutMinutes, false);
  }

  supressHidding() {
    this.recentlyPressed = true;
  }
 
  constructor() {
    //this.initialize();
  }


  private controls = new Map < string, AbstractControl>();
  mapControls(...mappings: VirtualKeyboardServiceMap[]) {
    for (let mapping of mappings) {
      this.controls.set(mapping.id, mapping.control);
    }
  }

  private registerGlobalHandlers() {
    window.addEventListener('input', this.handleInput);
    window.addEventListener('keydown', this.handleKeydown);
    window.addEventListener('click', this.handleClick);
    window.addEventListener('focusin', this.handleFocusIn);
    window.addEventListener('focusout', this.handleFocusOut);
  }

  // Unregister global event handlers
  private unregisterGlobalHandlers() {
    window.removeEventListener('input', this.handleInput);
    window.removeEventListener('keydown', this.handleKeydown);
    window.removeEventListener('click', this.handleClick);
    window.removeEventListener('focusin', this.handleFocusIn);
    window.removeEventListener('focusout', this.handleFocusOut);
  }


  private supported(element: HTMLElement) {
    if (!element?.nodeName)
      return false;

    if (element.nodeName == "TEXTAREA")
      return true;

    if (element.nodeName == "INPUT" && this.supportedInputTypes.find(x=> x == element.getAttribute("type")?.toLowerCase()))
      return true;


    return false;
  }

  private currentElement: HTMLInputElement;


  private isContainedInVirutalKeyborad(element: HTMLElement) {
    var parentElement = element;

    while (parentElement) {
      if (parentElement.className == "keyboard-container")
        return true;

      parentElement = parentElement.parentElement;
    }
    return false;
  }
  private handleClick = (event: MouseEvent) => {
    if (this.isContainedInVirutalKeyborad(<HTMLHtmlElement>event.target))
      return;

    if (!this.supported(<HTMLInputElement>event.target)) {
      this.hide();
      return;
    }
    else {
      this.show(); //in case the keyboard was closed, clicking ion the focus input will show it again
    }

  }
  private handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.hide();
    }
  }

  private handleInput = (event: Event) => {
    var input = (<HTMLInputElement>event.target);
    this.keyboard?.setInput(input.value);
    this.keyboard?.setCaretPosition(input.selectionStart);
  }

  private handleFocusIn = (event: FocusEvent) => {
    if (!this.supported(<HTMLElement>event.target)) {
      return;
    }

    this.currentElement = <HTMLInputElement>event.target;
    this.show();
  };

  private handleFocusOut = (event: FocusEvent) => {

    if (!this.supported(<HTMLElement>event.relatedTarget) && !this.recentlyPressed) {
      this.hide();
    }


  };

  private onVirtualKeyboardChanged = (input: string, e?: MouseEvent) => {
    let control = this.currentElement;
    control.value = input;
    this.triggerKeysEvent(control);
    var id = control.id;
    if (id) {
      var abstractControl = this.controls.get(id);
      abstractControl?.setValue(input);
    }


  };

  //tracks if the keyboard was pressed. Need to track it to handle the focusout properly since moving from input to keyboard cause the focus lose
  private recentlyPressed = false;
  private onVirtualKeyboardPressed = (button: string, e?: MouseEvent) => {
    this.recentlyPressed = true;
    setTimeout(() => {
      this.recentlyPressed = false;
      console.log("resetting", this.recentlyPressed);
    }, 1000);

    console.log("onVirtualKeyboardPressed", button, e);
    if (button === "{shift}" || button === "{lock}") this.switchLayout();
    if (button === "{tab}") {

      setTimeout(() => {
        this.focusNextElement(this.currentElement);
      }, 0);
    }

    //turn shift off after a key was pressed
    if (this.lastButton == "{shift}" && button != "{shift}") {
      this.switchLayout();
    }

    //if (button == "{enter}") {
    //  var control = this.loginWidget.currentInputControl;
    //  if (control == this.loginWidget.getUsernameControl()) {
    //    this.loginWidget.triggerUsernameUpdate();

    //    if (this.loginWidget.screenNumber == 1) {
    //      setTimeout(() => {
    //        this.loginWidget.getNextButton().click();
    //      }, 0);
    //    }
    //    if (this.loginWidget.screenNumber == 2) {
    //      setTimeout(() => {
    //        this.loginWidget.getPasswordControl().focus();
    //      }, 0);
    //    }

    //  }
    //  if (control == this.loginWidget.getPasswordControl()) {
    //    this.loginWidget.triggerPasswordUpdate();

    //    setTimeout(() => {
    //      this.loginWidget.getLoginButton().click();
    //    }, 0);

    //  }
    //}

    this.lastButton = button;
  };
  private supportedInputTypes = [
    "",
    "text",
    "password",
    "email",
    "search",
    "tel",
    "url",
    "number"
  ];

  private focusNextElement(current: HTMLElement) {
    var inputTypesArray = this.supportedInputTypes.map(x => `input[type="${x}"]`);
    var inputTypesString = inputTypesArray.join(",");
    const focusableSelectors = [
      inputTypesString  + ':not([disabled]):not([type="hidden"]):not(.xdsoft_autocomplete_hint)',
      'textarea:not([disabled])'
    ];
    const focusable = Array.from(document.querySelectorAll<HTMLElement>(focusableSelectors.join(',')))
      .filter(el => el.offsetParent !== null);

    const index = focusable.indexOf(current);
    if (index > -1) {
      const next = focusable[index + 1] || focusable[0];
      next.focus();
    }
  }
  private lastButton = "";

  //hides, removes handlers and remove the storage
  private off() {
    this.hide();
    this.unregisterGlobalHandlers();
//    this.utilities.writeCookie(this.enableKey,"false");
    this.controls.clear();
  }
  private triggerKeysEvent(control: HTMLInputElement) {
    var keyboardEvent = document.createEvent('KeyboardEvent');
    var initMethod = typeof keyboardEvent.initKeyboardEvent !== 'undefined' ? 'initKeyboardEvent' : 'initKeyEvent';

    keyboardEvent[initMethod](
      'keydown', // event type: keydown, keyup, keypress
      true, // bubbles
      true, // cancelable
      window, // view: should be window
      false, // ctrlKey
      false, // altKey
      false, // shiftKey
      false, // metaKey
      40, // keyCode: unsigned long - the virtual key code, else 0
      0, // charCode: unsigned long - the Unicode character associated with the depressed key, else 0
    );
    control.dispatchEvent(keyboardEvent);

  }


  private switchLayout() {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  };
  get enabled(): boolean {
    return this.utilities.readCookie(this.enableKey) === "true";
  }


  private set enabled(value: boolean) {
    this.utilities.writeCookie(this.enableKey, value ? "true" : "false", 60 * this.cookieTimeoutMinutes, false);

  }

  setEnabled(enabled: boolean) {
    console.log("VK:Enabled " + enabled);
    this.enabled =enabled;
    this.initialize();
  }

  private utilities = new IdmUtilities();

  public initialize() {
    if (!this.getShowOnscreenKeyboard())
      return;

    var value = this.enabled;

    if (!value) {
      this.off();
      //this.hide();
      //this.unregisterGlobalHandlers();
    }
    else {
      this.registerGlobalHandlers();
      setTimeout(() => {
        this.currentElement?.focus();
      }, 0);
    }
  }
  private show() {

    console.log("VK:configuring keyboard", this.enabled);
    //dont show it if it has been disabled
    if (!this.enabled)
      return;

    if (!this.keyboard) {
      this.keyboard = new Keyboard({
        tabCharOnTab: false,
        excludeFromLayout: {
          default: ["{enter}"],
          shift: ["{enter}"],
        },
        onChange: this.onVirtualKeyboardChanged,
        onKeyPress: this.onVirtualKeyboardPressed
      });
    }
    this.keyboard.setInput(this.currentElement.value);


  }

  private keyboard: Keyboard;

  private hide() {
    this.keyboard?.destroy();
    this.keyboard = null;



  }
}
